import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { api, formatErrorDetail } from "@/lib/api";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (localStorage.getItem("fcv_admin_token")) {
    return <Navigate to="/admin" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("fcv_admin_token", data.access_token);
      localStorage.setItem("fcv_admin", JSON.stringify(data.admin));
      toast.success(`Bienvenue ${data.admin.name}`);
      navigate("/admin");
    } catch (err) {
      toast.error(formatErrorDetail(err.response?.data?.detail) || "Identifiants invalides");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF9] flex items-center justify-center px-6">
      <form onSubmit={handleSubmit} className="w-full max-w-md bg-white border border-[#EADBD1] rounded-3xl p-10 shadow-sm" data-testid="admin-login-form">
        <div className="h-12 w-12 rounded-full bg-[#2C2420] grid place-items-center mb-6">
          <Lock className="h-5 w-5 text-white" />
        </div>
        <h1 className="font-serif text-3xl text-[#2C2420]">Administration</h1>
        <p className="text-sm text-[#6B5D54] mt-2">French Curl Vibes — accès réservé</p>

        <div className="mt-8 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-[0.22em] text-[#6B5D54] mb-1.5 block">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full h-11 px-4 rounded-xl bg-[#FDFBF9] border border-[#EADBD1] focus:border-[#C58C85] focus:outline-none text-sm"
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.22em] text-[#6B5D54] mb-1.5 block">Mot de passe</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full h-11 px-4 rounded-xl bg-[#FDFBF9] border border-[#EADBD1] focus:border-[#C58C85] focus:outline-none text-sm"
              data-testid="admin-password-input"
            />
          </div>
        </div>

        <Button
          type="submit"
          disabled={loading}
          className="w-full mt-8 rounded-full bg-[#2C2420] hover:bg-[#3a2f2a] text-white h-12"
          data-testid="admin-login-btn"
        >
          {loading ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Connexion…</> : "Se connecter"}
        </Button>
      </form>
    </div>
  );
}
